var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5279 30.2362H34.535L33.8287 29.5551C36.8559 26.0233 38.4199 21.205 37.5622 16.084C36.3766 9.07103 30.524 3.49594 23.4858 2.61301C13.9249 1.42735 5.75143 8.49081 5.07031 17.6229H10.1661C10.7715 12.2748 15.0096 8.03674 20.4081 7.58266C26.8157 7.02767 32.7439 12.4514 32.7439 18.8842C32.7439 25.1656 27.6734 30.2362 21.392 30.2362C20.9631 30.2362 20.5595 30.1605 20.1306 30.1101V35.2058C20.1306 35.2058 20.1306 35.2058 20.1558 35.2311C24.6966 35.559 28.9095 34.0454 32.0628 31.3209L32.7439 32.0273V34.0202L43.4653 44.7415C44.4996 45.7758 46.1897 45.7758 47.224 44.7415C48.2583 43.7072 48.2583 42.017 47.224 40.9827L36.5279 30.2362Z",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8656 23.097L7.51754 28.4451L2.16949 23.097C1.66496 22.5925 0.882933 22.5925 0.3784 23.097C-0.126133 23.6016 -0.126133 24.3836 0.3784 24.8881L5.72645 30.2362L0.3784 35.5842C-0.126133 36.0888 -0.126133 36.8708 0.3784 37.3753C0.882933 37.8798 1.66496 37.8798 2.16949 37.3753L7.51754 32.0273L12.8656 37.3753C13.3701 37.8798 14.1521 37.8798 14.6567 37.3753C15.1612 36.8708 15.1612 36.0888 14.6567 35.5842L9.30863 30.2362L14.6567 24.8881C15.1612 24.3836 15.1612 23.6016 14.6567 23.097C14.1521 22.6177 13.3701 22.6177 12.8656 23.097Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no_results.551e4d437a35ba9844effb9057f417b3.svg";
export { ForwardRef as ReactComponent };